export const AdvisorList = [
    {
        dept: 4,
        name: 'Kenneth Ng',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-kenneth.png',
    },
    {
        dept: 4,
        name: 'Kailee Poon',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-kailee.png',
    },
    {
        dept: 4,
        name: 'Sabrina Lerskiatiphanich',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-sabrina.png',
    },
    {
        dept: 4,
        name: 'Jo Yi Chow',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-joyi.png',
    },
    {
        dept: 4,
        name: 'Isabella Kroon',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-isabella.png',
    },
    {
        dept: 4,
        name: 'Angela Fan',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-angela.png',
    },
    {
        dept: 4,
        name: 'Diwen Shi',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-shidiwen.png',
    },
    {
        dept: 4,
        name: 'Timothy Ng',
        role: 'Advisor',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-tim.png',
    },
    {
        dept: 4,
        name: 'Sum Lau',
        role: 'Advisor',
        major: '',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/advisor-sum-lau.png',
    },
    {
        dept: 5,
        name: 'Dr. Amy Tan',
        role: 'Primary Principal Investigator',
        major: 'Research Assistant Professor in HKU Department of Civil Engineering',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/pi-dr-tan.png',
    },
    {
        dept: 5,
        name: 'Dr. Juan Diego Gaitan-Espitia',
        role: 'Primary Principal Investigator',
        major: 'Assistant Professor in HKU School of Biological Sciences',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/pi-dr-juan.png',
    },
    {
        dept: 5,
        name: 'Dr. Edmond Tse',
        role: 'Secondary Principal Investigator',
        major: 'Assistant Professor in HKU Department of Chemistry',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/pi-dr-tse.png',
    },
]